import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'


const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState('all');
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          During my journey as a DevOps Engineer, I have worked and created a few projects. Here are some of them.
        </Desc>
        <ToggleButtonGroup >
          {toggle === 'all' ?
            <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
            :
            <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
          }
          <Divider />
          {toggle === 'Personal Projects' ?
            <ToggleButton active value="Personal Projects" onClick={() => setToggle('Personal Projects')}>Personal Projects</ToggleButton>
            :
            <ToggleButton value="Personal Projects" onClick={() => setToggle('Personal Projects')}>Personal Projects</ToggleButton>
          }
          <Divider />
          {toggle === 'School Projects' ?
            <ToggleButton active value="School Projects" onClick={() => setToggle('School Projects')}>School Projects</ToggleButton>
            :
            <ToggleButton value="School Projects" onClick={() => setToggle('School Projects')}>School Projects</ToggleButton>
          }
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === 'all' && projects
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal} />
            ))}
          {projects
            .filter((item) => item.category == toggle)
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal} />
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects